module.exports = __webpack_public_path__ + "assets/shangc.3fd66878d7a0090c688d12984a0a47b4.png";